import React from 'react';
import { Card, CardHeader, Collapse, CardBody } from 'reactstrap';
import PropTypes from 'prop-types';
import { translateResourceString } from '../../../util/translationUtility';
import sortBy from 'lodash/sortBy';
import { createGuid } from '../../../util/guidUtility';

const downArrow = <i className="icon-arrow icon-arrow--down" />;
const upArrow = <i className="icon-arrow icon-arrow--up" />;
const showMoreThreshold = 10;

class Facet extends React.Component {
    componentWillMount() {
        this.setState({ expanded: true });
    }

    render() {
        const {
            name,
            displayName,
            values,
            onAttributeChange,
            expanded,
            onToggleFacetExpanded,
            updateOnToggle,
            showMore,
            onToggleShowMore,
        } = this.props;
        const arrow = expanded ? upArrow : downArrow;
        const sizeToShow = showMore
            ? values.length
            : Math.min(showMoreThreshold, values.length);
        const showShowMore = !showMore && values.length > showMoreThreshold;
        const showShowLess = showMore && values.length > showMoreThreshold;
        return (
            <Card className="facet-card">
                <details className="facet-card__header">
                    <summary className="facet-card__title" onClick={() => onToggleFacetExpanded(name)}>
                        <h4 className="facet-card__title-text heading-sm mb-0">
                            {displayName}
                        </h4>
                        <span className="facet-card__title-icon">
                            {arrow}
                        </span>
                    </summary>
                </details>
                <Collapse
                    isOpen={expanded}
                    className="facet-card__collapse">
                    <div className="list-group">
                        {
                            sortBy(values, a => a.name)
                                .slice(0, sizeToShow)
                                .map((value, k) => {
                                    // generate unique ID
                                    const uniqueGuid = createGuid();
                                    return (
                                        <div key={k} className={"list-group-item d-flex justify-content-start list-group-item-action" + (value.checked ? " active" : "")}
                                            onClick={() => {
                                                if (updateOnToggle) {
                                                    value.checked = !value.checked;
                                                }
                                                onAttributeChange(name, value.name);
                                            }}
                                        >
                                            <input type="checkbox" id={uniqueGuid} className="d-none"></input>
                                            <i className="list-group-item__icon"></i>
                                            <label htmlFor={uniqueGuid} className="control-label list-group-item__text">{value.displayName}</label>

                                        </div>
                                    )
                                })
                        }
                        {showShowMore && <button className="show-more" role="button" onClick={() => onToggleShowMore(name)}>{translateResourceString("/Search/ShowMoreFacets")}</button>}
                        {showShowLess && <button className="show-less" role="button" onClick={() => onToggleShowMore(name)}>{translateResourceString("/Search/ShowLessFacets")}</button>}
                    </div>
                </Collapse>
            </Card>
        );
    }
}

Facet.propTypes = {
    name: PropTypes.string.isRequired,
    displayName: PropTypes.string.isRequired,
    values: PropTypes.arrayOf(PropTypes.shape({
        displayName: PropTypes.string,
        name: PropTypes.string,
        checked: PropTypes.bool,
        count: PropTypes.number
    })).isRequired,
    onAttributeChange: PropTypes.func,
    expanded: PropTypes.bool,
    onToggleFacetExpanded: PropTypes.func,
    updateOnToggle: PropTypes.bool,
    showMore: PropTypes.bool,
    onToggleShowMore: PropTypes.func,
};

export default Facet;